import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { JobList, JobSearch } from "../../../../Constants/Constants";
import RightSidebarCards from "../Common/RightSidebarCards/RightSidebarCards";
import LeftSidebar from "../Common/LeftSidebar/LeftSidebar";
import { Fragment } from "react/jsx-runtime";

const ListViewContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={JobList} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <Col xl="9" className="xl-60 box-col-12">
            <RightSidebarCards startLimit={0} endLimit={8} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default ListViewContainer;
